import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { ArrowLeft, Calendar, MapPin, Clock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EventoDettaglio() {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/events/${id}`)
      .then(r => setEvent(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return (
    <div className="max-w-4xl mx-auto px-4 py-20">
      <Skeleton className="h-8 w-64 mb-4" />
      <Skeleton className="h-64 rounded-xl mb-6" />
      <Skeleton className="h-4 w-full mb-2" />
      <Skeleton className="h-4 w-3/4" />
    </div>
  );

  if (!event) return (
    <div className="max-w-4xl mx-auto px-4 py-20 text-center">
      <p className="text-lg text-muted-foreground mb-4">Evento non trovato</p>
      <Link to="/eventi"><Button variant="outline"><ArrowLeft size={16} className="mr-2" /> Torna agli eventi</Button></Link>
    </div>
  );

  return (
    <div>
      <section className="hero-wash py-10 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/eventi" className="inline-flex items-center text-sm text-[#238A92] hover:underline mb-4">
            <ArrowLeft size={16} className="mr-1" /> Tutti gli eventi
          </Link>
          {event.categoria && <Badge className="mb-3 bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))]">{event.categoria}</Badge>}
          <h1 className="text-3xl sm:text-4xl font-bold text-[#1F2A37] mb-4" style={{fontFamily:'Space Grotesk'}}>{event.titolo}</h1>
          <div className="flex flex-wrap items-center gap-4 text-muted-foreground">
            <span className="flex items-center gap-2"><Calendar size={16} /> {new Date(event.data_evento).toLocaleDateString('it-IT', {weekday:'long', day:'numeric', month:'long', year:'numeric'})}</span>
            {event.ora_inizio && <span className="flex items-center gap-2"><Clock size={16} /> {event.ora_inizio}{event.ora_fine ? ` - ${event.ora_fine}` : ''}</span>}
            {event.luogo && <span className="flex items-center gap-2"><MapPin size={16} /> {event.luogo}</span>}
          </div>
        </div>
      </section>

      <section className="py-10 sm:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {event.immagine_url && (
            <div className="rounded-2xl overflow-hidden shadow-[var(--shadow-md)] mb-8">
              <img src={event.immagine_url} alt={event.titolo} className="w-full max-h-[500px] object-cover" />
            </div>
          )}
          {event.descrizione && (
            <div className="prose max-w-none">
              {event.descrizione.split('\n').map((p, i) => (
                <p key={`desc-${i}`} className="text-muted-foreground leading-relaxed mb-4">{p}</p>
              ))}
            </div>
          )}
          <div className="mt-10 pt-6 border-t">
            <Link to="/prenota">
              <Button className="bg-[#238A92] hover:bg-[#0F5E66] text-white">Prenota un Appuntamento</Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
